import { Grid } from '@grupoboticario/flora-react'

import FormField from '@/components/FormField/FormField'
import Gender from '@/components/RegisterData/components/Gender/Gender'
import Nationality from '@/components/RegisterData/components/Nationality/Nationality'
import { useHeaderContext } from '@/context/header'
import { labelByDocumentType } from '@/utils/format/documentNumber'

import * as S from './UserInfos.styles'

const UserInfos = ({ errors, handleChange, isDisabled = false, newMember = false }) => {
  const { member } = useHeaderContext()

  return (
    <Grid align="start" css={S.userInfosGridCss} gap="$4">
      <FormField
        disabled={isDisabled}
        invalid={typeof errors?.givenName === 'string'}
        invalidText={errors?.givenName}
        labelText="Nome: "
        name="givenName"
        required
      />
      <FormField
        disabled={isDisabled}
        invalid={typeof errors?.familyName === 'string'}
        invalidText={errors?.familyName}
        labelText="Sobrenome: "
        name="familyName"
        required
      />
      {!newMember && <FormField disabled={isDisabled} labelText="Apelido: " name="nickName" />}
      {!newMember && (
        <FormField disabled labelText={`${labelByDocumentType(member?.documentType)}: `} name="documentNumber" />
      )}
      <Nationality handleChange={handleChange} isDisabled={isDisabled} />
      <Gender errors={errors} handleChange={handleChange} isDisabled={isDisabled} />
      <FormField
        disabled={isDisabled}
        invalid={typeof errors?.birthDate === 'string'}
        invalidText={errors?.birthDate}
        labelText="Nascimento: "
        name="birthDate"
        required
        type="date"
      />
      {!newMember && <FormField disabled labelText="Criado em: " name="createdAt" />}
      {!newMember && <FormField disabled labelText="Atualizado em: " name="updatedAt" />}
    </Grid>
  )
}

export default UserInfos
